import {
  Component,
  Inject,
  OnInit,
  OnDestroy,
  ChangeDetectionStrategy,
} from '@angular/core'
import { MAT_DIALOG_DATA } from '@angular/material/dialog'
import { I18nService } from '@containers/i18n/i18n.service'
import { UpdateTranslationManualy } from '@containers/i18n/store/i18n.actions'
import {
  translation,
  TranslationObject,
} from '@containers/i18n/store/i18n.interface'
import { getDefaultTranslationsState } from '@containers/i18n/store/i18n.selector'
import { select, Store } from '@ngrx/store'
import { Observable, race, Subscription } from 'rxjs'
import { filter, map, finalize, take } from 'rxjs/operators'
import { MatDialogRef } from '@angular/material/dialog'
import { ShowSnackbar } from '@shared/shared.actions'
import { TranslateService } from '@ngx-translate/core'
import { Actions, ofType } from '@ngrx/effects'
import * as i18nTypes from '../../store/i18n.types'
@Component({
  selector: 'app-translation-update-confirmation',
  templateUrl: './translation-update-confirmation.component.html',
  styleUrls: ['./translation-update-confirmation.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TranslationUpdateConfirmationComponent
  implements OnInit, OnDestroy
{
  defaultTranslations: translation
  isLoading = false
  private _subs: Array<Subscription> = []

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: {
      defaultValue?: any
      translation: TranslationObject
      iso2code: string
    },
    private store: Store<Observable<any>>,
    private i18nService: I18nService,
    private matDialogRef: MatDialogRef<TranslationUpdateConfirmationComponent>,
    private translateService: TranslateService,
    private updates$: Actions,
  ) {}

  ngOnInit() {
    this.getDefaultTranslations()
  }

  ngOnDestroy(): void {
    this._subs.filter((sub) => Boolean(sub)).forEach((sub) => sub.unsubscribe())
  }

  getDefaultTranslations() {
    const sub = this.store
      .pipe(
        select(getDefaultTranslationsState),
        filter((state) => Boolean(state)),
        map((state) => state.toJS()),
      )
      .subscribe((translations) => {
        this.defaultTranslations = translations
      })

    this._subs.push(sub)
  }

  resetToDefault() {
    this.crudHandler(
      this.i18nService.deleteKey(this.data.translation.key, this.data.iso2code),
      true,
    )
  }

  updateTranslation() {
    this.crudHandler(
      this.i18nService.updateKey(this.data.translation, this.data.iso2code),
    )
  }

  crudHandler(obs: Observable<any>, forceRestore = false) {
    this.isLoading = true
    obs.subscribe(
      (res) => {
        this.store.dispatch(new UpdateTranslationManualy(this.data.iso2code))

        const success = this.updates$.pipe(
          ofType(i18nTypes.UPDATE_TRANSLATIONS_MANUALY_SUCCESSFULLY),
          take(1),
        )

        const failure = this.updates$.pipe(
          ofType(i18nTypes.UPDATE_TRANSLATIONS_MANUALY_FAILURE),
          take(1),
        )

        race(success, failure).subscribe(() => {
          this.isLoading = false
          this.cancel(forceRestore)

          this.store.dispatch(
            new ShowSnackbar({
              type: 'success',
              message: this.translateService.instant(
                'OPERATION_FINISHED_SUCCESSFULLY',
              ),
            }),
          )
        })
      },
      (err) => {
        this.isLoading = false
        this.cancel(true)
      },
    )
  }

  cancel(restore: boolean = true) {
    this.matDialogRef.close(restore)
  }

  get canRestoreToDefault(): boolean {
    return this.data.translation.key in
      this.translateService.store.translations[this.data.iso2code] ||
      (this.data.defaultValue &&
        this.data.translation.value !== this.data.defaultValue)
      ? true
      : false
  }
}
